import { SharedValues } from './../core/shared-values';
import { Component, OnInit, ChangeDetectorRef, AfterViewChecked, OnDestroy } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { SessionService } from '../services/session.service';
import { UserService } from '../user/user.service';
import { GuestService } from '../shared/services/guest.service';
import { Router, RouterLink } from '@angular/router';
import { SharedService } from '../shared/shared.service';
import { IBuyerErrorModal } from '../buyer/interfaces/IBuyerErrorModal';
import { CartService } from '../buyer/cart/cart.service';
import { environment } from '../../environments/environment';
import { ConnectionManagerService } from '../shared/services/signalR/connection-manager.service';
import { eConnectionType } from '../shared/services/signalR/connection-type';
import { ItemsService } from '../shared/services/items.service';
import { Subscription } from 'rxjs';
import { PubSubService } from '../core/pubsub.service';
import { SharedSource } from '../core/shared-source';
import { OfferService } from '../user/offers/offer.service';
import { IOfferEventMessage, IOfferFeatureSwitchedMessage, IOfferSeenMessage } from '../shared/interfaces/IOfferNotificationMessage';
import { TopService } from '../shared/services/top.service';
import { UserFiltersService } from '../buyer/user-filters/user-filters.service';
import { BuyerOffersService } from '../buyer/buyers-offers/buyer-offers.service';
import { ConfirmationPopupComponent } from '../shared/confirmation-popup/confirmation-popup.component';
import { ErrorModalComponent } from '../shared/ui-components/error-modal/error-modal.component';
import { GuestTopComponent } from '../buyer/top/guest-top/guest-top.component';
import { TopVendorComponent } from '../vendor/top-vendor/top-vendor.component';
import { TopComponent } from '../buyer/top/top.component';
import { GuestTopFullComponent } from '../buyer/top/guest-top-full/guest-top-full.component';
import { NgIf, NgClass } from '@angular/common';
import { OfferEventTypes } from '../shared/enums/offer-types';


@Component({
  selector: 'app-main-top',
  templateUrl: './main-top.component.html',
  styleUrls: ['./main-top.component.scss', '../shared/confirm-modal/confirm-modal.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, RouterLink, GuestTopFullComponent, TopComponent, TopVendorComponent, GuestTopComponent, ErrorModalComponent, ConfirmationPopupComponent]
})
export class MainTopComponent implements OnInit, AfterViewChecked, OnDestroy {
  role: string;
  navToggle = false;
  selectedLink = '';
  sessionErrorModal: IBuyerErrorModal = {
    bodyText: 'Your session has expired. Please login again.',
    title: 'Sorry!'
  };
  maintenanceModeOn = false;
  impersonationListEmptyShowPopup = false;
  subscription: Subscription = new Subscription();

  constructor(
    public authService: AuthService,
    public userService: UserService,
    public sessionService: SessionService,
    public cdr: ChangeDetectorRef,
    public guestService: GuestService,
    public router: Router,
    public itemsService: ItemsService,
    public sharedService: SharedService,
    public cartService: CartService,
    public pubSubService: PubSubService,
    public connManagerService: ConnectionManagerService,
    public offerService: OfferService,
    public buyerOffersService: BuyerOffersService,
    public userFiltersService: UserFiltersService,
    public topService: TopService) { }

  ngOnInit() {
    this.role = this.sessionService._user_role;
    this.startConnections();
    this.authService.roleChanged.subscribe(role => this.onRoleChanged(role));

    this.authService.getInitialOfferData();
    if (environment.maintenanceMode) {
      this.maintenanceModeOn = true;
    }

    this.subscription.add(
      this.pubSubService.sharedSubject
        .subscribe(myEvent => {
          if (myEvent.name === SharedSource.partnerIdReady) {
            if (!this.connManagerService.connections.has('Notification')) {
              this.startConnections();
            }
          }

          switch (myEvent.name) {
            case SharedSource.handleOfferFeatureSwitched:
              this.offerService.handleOfferFeatureSwitched(myEvent.data as IOfferFeatureSwitchedMessage, this.cdr);
              break;

            case SharedSource.tokenCountUpdated:
              this.offerService.getTokenCountNotream();
              break;

            case SharedSource.offerValidationRulesUpdated:
              this.offerService.getValidationRulesNotream();
              break;

            case SharedSource.offerSeen:
              this.offerService.handleCountersDueToOfferSeenReceived(myEvent.data as IOfferSeenMessage);
              break;

            case SharedSource.offerEvent:
              const offerEventMessage: IOfferEventMessage = myEvent.data;
              const offerId = offerEventMessage.offerId;

              // handle offer event for live offers
              const url = this.router.url;
              if (url.match(/live_offers/)) {
                if (offerEventMessage.eventType !== OfferEventTypes.OrderCreated) {
                  const buyerOffersQty = this.pubSubService.getSignal(SharedSource.buyerOffersQty);
                  const sharedValue: SharedValues = {
                    name: SharedSource.buyerOffersQty,
                    data: buyerOffersQty() ? buyerOffersQty().data + 1 : 1
                  };
                  this.pubSubService.emit(sharedValue);
                }
              } else if ([
                  OfferEventTypes.OfferMade,
                  OfferEventTypes.VendorAcceptedOffer,
                  OfferEventTypes.VendorRejectedOffer,
                  OfferEventTypes.BuyerAcceptedOffer,
                  OfferEventTypes.BuyerRejectedOffer,
                  OfferEventTypes.BuyerCancelledOffer,
                  OfferEventTypes.VendorCancelledOffer,
                  OfferEventTypes.SystemCancelledOffer,
                  OfferEventTypes.BuyersOfferExpired,
                  OfferEventTypes.VendorsOfferExpired,
                  OfferEventTypes.VendorAcceptedPreviousOffer,
                  OfferEventTypes.BuyerAcceptedPreviousOffer,
                  OfferEventTypes.OfferTaken
                ].includes(offerEventMessage.eventType)) {
                  this.buyerOffersService.getLiveOffersCounter();
                }
              // Check if it is necessary to react in offer chat
              this.buyerOffersService.offerBusinessPartners(offerId)
                .subscribe((offerBusinessPartner) => {
                  const currentBP = sessionStorage.getItem('partner_id');
                  const isBuyer = ['SUPER', 'SALES', 'BUYER'].includes(sessionStorage.getItem('user_role'));
                  const isVendor = ['ADMIN', 'SELLER', 'VENDORMGR'].includes(sessionStorage.getItem('user_role'));

                  if (url === '/user/offers'){
                     const selectedOffer = this.offerService.selectedOffer;
                     const offerEvent = selectedOffer.offerEvents.find(oe=>oe.id===offerEventMessage.eventId);
                     if (offerEvent) {
                       return;
                     }
                  }

                  if (isBuyer && OfferEventTypes.OrderCreated == offerEventMessage.eventType && offerBusinessPartner.takenBy != null) {
                    return; // ignore
                  }

                  if (isBuyer && offerBusinessPartner.madeBy === currentBP || isVendor && offerBusinessPartner.seller === currentBP) {
                    this.offerService.handleCountersDueToNewOfferEvent(myEvent.data);
                  }

                });
              break;
            case SharedSource.userProfileLoaded:
              this.setUserProfile(myEvent.data);
              break;

            default:
              break;
          }

        }));
  }

  setUserProfile(data) {
    this.userService.userProfile = Object.assign({}, data);
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  getUserRole(): string {
    return (this.authService.userRole);
  }

  onRoleChanged(role: string): void {
    this.role = role;
  }

  navigateTo(url: string): void {
    this.sharedService.corporateSiteSelectedLink = url;
    this.router.navigate([url]);

    if (url === 'vendor-login') {
      this.userService.foundBP = false;
    }
    if (url === 'guest/home') {
      this.itemsService.isLandingPage = true;
      this.sharedService.isStaticHtml = false;
      this.sharedService.isCorpSite = false;
      return;
    }
    this.sharedService.staticHtmlUrl = url;
    if (this.sharedService.isVendorLoginUrl) {
      this.sharedService.isStaticHtml = false;
      this.sharedService.isCorpSite = false;
      return;
    }

    this.sharedService.isCorpSite = true;
    this.sharedService.isStaticHtml = true;
  }

  clickLogoToReload(): void {
    this.sharedService.corporateSiteSelectedLink = 'logo';
    this.sharedService.isStaticHtml = false;
    this.router.navigate(['/guest/home']);
  }

  toggleNav(): void {
    this.navToggle = !this.navToggle;
  }

  close() {
    this.navToggle = false;
  }

  isOnBuyerLogin(): boolean {
    return this.router.url !== '/products' && this.router.url !== '/faq' && this.router.url !== '/sell' && this.router.url !== '/corphome'
      && this.router.url !== '/aboutUs' && !this.sharedService.isVendorLoginUrl && this.router.url !== '/contact-support'
      && this.router.url !== '/page-error';

  }

  isOnVendorLogin(): boolean {
    return this.sharedService.isVendorLoginUrl;
  }

  showError(errorModal: IBuyerErrorModal): void {
    this.sessionErrorModal = errorModal;
  }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  handleExpiredSession(): void {
    this.userFiltersService.clearUserFilterList();
    this.cartService.resetCart();
    this.userService.logout();
  }

  startConnections() {
    switch (this.role) {
      case 'BUYER': {
        const userId = sessionStorage.getItem('user_id');
        this.connManagerService.addConnection(eConnectionType.Notification, userId);
        this.connManagerService.addConnection(eConnectionType.JustSold);
        this.connManagerService.addConnection(eConnectionType.Offer);
        break;
      }
      case 'SALES': {
        const userId = sessionStorage.getItem('user_id');
        this.connManagerService.addConnection(eConnectionType.Notification, userId);
        this.connManagerService.addConnection(eConnectionType.JustSold);
        this.connManagerService.addConnection(eConnectionType.Offer);
        break;
      }
      case 'SUPER': {
        const userId = sessionStorage.getItem('user_id');
        this.connManagerService.addConnection(eConnectionType.Notification, userId);
        this.connManagerService.addConnection(eConnectionType.JustSold);
        this.connManagerService.addConnection(eConnectionType.Offer);
        break;
      }
      case 'SELLER':
      case 'ADMIN':
      case 'VENDORMGR': {
        this.connManagerService.addConnection(eConnectionType.Offer);
        const partnerId = sessionStorage.getItem('partner_id');
        if (partnerId) {
          this.connManagerService.addConnection(eConnectionType.Notification, partnerId);
          this.connManagerService.addConnection(eConnectionType.JustSold);
        }
        break;
      }
    }
  }

  handleImpersonationListEmpty(): void {
    this.impersonationListEmptyShowPopup = true;
    this.userService.logout();
  }

  hideImpersonationErrorPopup(): void {
    this.impersonationListEmptyShowPopup = false;
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
